import React, { useState, useEffect } from 'react'
import Select from 'react-select'
import { CButton, CCard, CCardBody, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CFormLabel, CFormInput, CSpinner, CNav, CNavItem, CNavLink, CCardHeader, CCardTitle, CCardText, CCol, CRow, CAlert, CTooltip } from '@coreui/react'
import { CircleAlertIcon, Pencil, Trash2, ListOrdered, Info, AlignLeft, CirclePlus, View, Eye, Settings, RefreshCw } from 'lucide-react'

import Pageloader from '../../components/shared/Pageloader'
import PatientInfo from './PatientInfo'
import PatientDataCRUD from '../../services/general/patientNoteData.api'
import ModifyPatientMap from '../../services/general/modifyPatientMap.api'
import PatientNoteDataCRUD, { clearNoteCache } from '../../services/general/patientNoteData.api'
import SavePatients from '../../services/general/savePatientinformation.api'
import PatientInsuranceFn from '../../services/general/PatientInsuranceAPI.api'
import FacilityCRUD from '../../services/general/getFacilityData.api.js'
import { HiEye } from 'react-icons/hi'
import SaveExtra from '../../services/general/saveExtraData.api'
import classNames from 'classnames'
import { backgroundColor } from '@syncfusion/ej2-richtexteditor/src/rich-text-editor/models/items'
import PatientInfoFreeType from './PatientInfoFreetype'
import { shouldDisableCreateNote, getCreateNoteDisabledReason } from '../../utils/noteButtonRules'
import { getAllAppointmentsDetails } from '../../components/shared/appointmentFilterData.jsx'

import toast from 'react-hot-toast'
import { toastConfig } from '../../constants/other.config'

const PatientPopup = ({
  patientData,
  noteStructureRef,
  showCreateNote = true,
  setNoteStatus,
  noteStatus,
  patientID,
  setPatientModalVisible,
  setDataCallType,
  setShowPatientInfo,
  setEditDataId,
  setNoteID,
  patientSelected,
  showOnlyViewEye = false,
  childformData,
  setChildFormData,
  saveDiagnosisData,
  resetStates,
  setAllSelectedDiagnosis,
  breadCrumbHref,
  breadCrumbText,
  patientAppointmentID,
  appointment = [],
  viewPatientDetail,
  creatingNewNote = false,
  setCreatingNewNote = () => { },
  handleAddNoteId,
  showViewIcon = false,
  allAppointment,
  noteButtonContext = 'dashboard',
}) => {
  const [diagnosisData, setDiagnosisData] = useState([])
  const [selectedDiagnosis, setSelectedDiagnosis] = useState(null)
  const [deleteVisibleId, setDeleteVisibleId] = useState(null)
  const [isPageLoading, setIsPageLoading] = useState(false)
  const [boxView, setBoxView] = useState('box')
  const [warningModelVisible, setWarningModelVisible] = useState(false)
  const [patientTreatments, setPatientTreatments] = useState(null)
  const [deleteId, setDeleteId] = useState(null)
  const [allowCreateNote, setAllowCreateNote] = useState(true)
  const [allPatientVisible, setAllPatientVisible] = useState(false)
  const [settingsModalVisible, setSettingsModalVisible] = useState(false)
  const [facilityOptions, setFacilityOptions] = useState([])
  const [selectedService, setSelectedService] = useState(null)
  const [originalService, setOriginalService] = useState('')
  const [settingsModalMode, setSettingsModalMode] = useState('edit')
  const [isPatientDetailsLoading, setIsPatientDetailsLoading] = useState(false)
  const [isSavingService, setIsSavingService] = useState(false)
  const [currentPatientDetails, setCurrentPatientDetails] = useState(null)
  const [facilityDirectory, setFacilityDirectory] = useState([])
  const [showNotePatient, setShowNotePatient] = useState(false)
  const [noteId, setNodeId] = useState(null)
  const [noteIndex, setNoteIndex] = useState(false)
  const [selectedSettingsNote, setSelectedSettingsNote] = useState(null)
  const [finishNote, setFinishNote] = useState({})
  const [hasFinishNote, setHasFinishNote] = useState(false)
  const [patientAllAppointment, setPatientAllAppointment] = useState([])
  const [isRetryingLink, setIsRetryingLink] = useState(false)
  const [syncingNoteId, setSyncingNoteId] = useState(null)
  const [noteIdsBeforeCreate, setNoteIdsBeforeCreate] = useState(null)
  const normalizePatientStatus = (status) => String(status || '').trim().toLowerCase()
  const isDischargedStatus = (status) => ['discharge', 'discharged'].includes(normalizePatientStatus(status))
  const isActiveNoteStatus = (status) => ['draft', 'drafted', 'in draft', 'submitted'].includes(normalizePatientStatus(status))
  const notesLoaded = Array.isArray(patientTreatments)
  const latestNoteIsActive = notesLoaded && isActiveNoteStatus(patientTreatments[0]?.status || patientTreatments[0]?.Status)
  const isPatientDischarged = notesLoaded && isDischargedStatus(patientData?.Status) && !latestNoteIsActive
  const isDisabled = allowCreateNote || creatingNewNote || isPatientDischarged
  const createNoteDisabledReason = isPatientDischarged
    ? 'Patient Is Discharged'
    : getCreateNoteDisabledReason({
      context: noteButtonContext,
      appointment,
      patientAppointmentID,
      patientTreatments,
    })
  const [createdNoteId, setCreatedNoteId] = useState(null)
  const NOTE_LINK_MAX_RETRIES = 6
  const NOTE_LINK_RETRY_DELAY_MS = 700
  const visiblePatientTreatments =
    creatingNewNote && Array.isArray(noteIdsBeforeCreate)
      ? (patientTreatments || []).filter((item) => noteIdsBeforeCreate.includes(String(item?.id)))
      : patientTreatments
  // const getPatientDiagnosis = async () => {
  //     let diagnosisData = await ModifyPatientMap("GETALL", patientID, "")
  //     let tempData = JSON.parse(diagnosisData.d)?.Data

  //     diagnosisData = tempData.filter(obj => { if (patientID == obj.PatientID) { return obj } })
  //     let patientD = []
  //     try {
  //         patientD = diagnosisData[0]?.Diagnosis?.split(',')
  //          setAllSelectedDiagnosis(patientD)
  //     } catch (e) {

  //     }

  // }

  // const patientDataFn = async () => {
  //     setIsPageLoading(true)
  //     try {
  //         let patientData = await SavePatients("GetAll", "", "", "");
  //         setPatientData(JSON.parse(patientData.d).Data);

  //     } catch (error) {
  //         console.log(error)
  //     } finally {
  //         setIsPageLoading(false)
  //     }
  // }
  const getFormattedDate = () => {
    const today = new Date()
    const dd = String(today.getDate()).padStart(2, '0')
    const mm = String(today.getMonth() + 1).padStart(2, '0') // January is 0!
    const yyyy = today.getFullYear()
    const hh = String(today.getHours()).padStart(2, '0')
    const min = String(today.getMinutes()).padStart(2, '0')
    return `${mm}/${dd}/${yyyy} ${hh}:${min}`
  }

  const getNoteTime = (note = {}) => new Date(note.newDate || note.date || note.data?.date || note.data?.CreatedDate || note.data?.createdDate || 0).getTime() || 0
  const getNoteId = (note = {}) => Number(note.id || note.Id || 0) || 0

  const getDisplayedNoteStatus = (note = {}) => {
    const noteData = note?.data || {}
    const rawStatus = String(note?.status || note?.Status || '').trim()
    const isSigned = rawStatus.toLowerCase() === 'signed' || !!noteData?.signedAt || !!noteData?.signatureInfo?.signedDate
    return isSigned ? 'Signed' : rawStatus || 'Not Created'
  }

  const getDisplayedNoteService = (note = {}) => {
    const noteData = note?.data || {}
    return String(
      noteData?.Service ||
      noteData?.service ||
      note?.Services ||
      note?.Service ||
      '',
    ).trim()
  }

  const parseFacilityTypeOptions = (facilityType) => {
    if (!facilityType || typeof facilityType !== 'string') return []
    const [, optionsSegment = facilityType] = facilityType.split(':')

    return optionsSegment
      .split(',')
      .map((item) => item.trim())
      .filter(Boolean)
      .map((item) => ({
        value: item,
        label: item,
      }))
  }

  const extractPatientRecords = (response) => {
    if (!response) return []
    if (Array.isArray(response)) return response

    if (typeof response?.d === 'string') {
      try {
        const parsed = JSON.parse(response.d)
        if (Array.isArray(parsed)) return parsed
        if (Array.isArray(parsed?.Data)) return parsed.Data
      } catch (error) {
        console.error('Unable to parse patient details response', error)
      }
    }

    if (Array.isArray(response?.Data)) return response.Data
    if (Array.isArray(response?.data)) return response.data

    return []
  }

  const parseInsuranceDetails = (insuranceResponse) => {
    try {
      const parsed = JSON.parse(insuranceResponse?.d)?.Data || []
      return Array.isArray(parsed) ? parsed : []
    } catch (error) {
      console.error('Unable to parse patient insurance response', error)
      return []
    }
  }
 console.log("patientData", patientData)
  const normalizeLookupValue = (value = '') => String(value || '').trim().toLowerCase()

  const findFacilityDirectoryMatch = (patientRecord = {}) => {
    const recordFacilityId = normalizeLookupValue(patientRecord?.FacilityID)
    const recordFacilityName = normalizeLookupValue(patientRecord?.FacilityName)

    return facilityDirectory.find((facility) => {
      const facilityId = normalizeLookupValue(facility?.ID || facility?.FacilityID)
      const facilityName = normalizeLookupValue(facility?.Name || facility?.FacilityName)

      return (
        (recordFacilityId && facilityId && recordFacilityId === facilityId) ||
        (recordFacilityName && facilityName && recordFacilityName === facilityName)
      )
    }) || null
  }

  const hydratePatientRecord = (patientRecord = {}) => {
    if (!patientRecord || typeof patientRecord !== 'object') return {}

    const matchedAppointment = getMatchingAppointmentForPatient()
    const matchedFacility = findFacilityDirectoryMatch(patientRecord)

    return {
      ...patientRecord,
      FacilityID:
        patientRecord?.FacilityID ||
        matchedAppointment?.data?.FacilityID ||
        matchedAppointment?.current?.Facility?.value ||
        matchedFacility?.ID ||
        matchedFacility?.FacilityID ||
        '',
      FacilityName:
        patientRecord?.FacilityName ||
        matchedAppointment?.data?.Facility ||
        matchedAppointment?.current?.Facility?.label ||
        matchedFacility?.Name ||
        matchedFacility?.FacilityName ||
        '',
      Room:
        patientRecord?.Room ||
        matchedAppointment?.data?.Room ||
        '',
      FacilityType:
        patientRecord?.FacilityType ||
        matchedAppointment?.data?.FacilityType ||
        matchedAppointment?.current?.Facility?.Type ||
        matchedAppointment?.current?.Facility?.type ||
        matchedFacility?.Type ||
        matchedFacility?.FacilityType ||
        '',
      PatientType:
        patientRecord?.PatientType ||
        patientRecord?.patientType ||
        patientData?.PatientType ||
        patientData?.patientType ||
        '',
      patientType:
        patientRecord?.patientType ||
        patientRecord?.PatientType ||
        patientData?.patientType ||
        patientData?.PatientType ||
        '',
      Services:
        patientRecord?.Services ||
        patientRecord?.services ||
        patientData?.Services ||
        patientData?.services ||
        '',
    }
  }

  const fetchResolvedPatientDetails = async () => {
    if (!patientID) return null

    let patientRecord = null

    try {
      const response = await SavePatients('GET', '', '', '', patientID)
      patientRecord = extractPatientRecords(response)[0] || null
    } catch (error) {
      console.error('Failed to load patient details with GET', error)
    }

    if (!patientRecord) {
      try {
        const response = await SavePatients('GetAll', '', '', '')
        const patientRecords = extractPatientRecords(response)
        patientRecord = patientRecords.find((record) => String(record?.PatientID) === String(patientID)) || null
      } catch (error) {
        console.error('Failed to load patient details with GetAll fallback', error)
      }
    }

    const fallbackRecord =
      patientRecord ||
      currentPatientDetails ||
      patientData ||
      {}

    return hydratePatientRecord(fallbackRecord)
  }

  const loadFacilityDirectory = async () => {
    try {
      const response = await FacilityCRUD('SELECT', {})
      const parsedFacilities = JSON.parse(response?.d || '{}')?.Data || []
      setFacilityDirectory(Array.isArray(parsedFacilities) ? parsedFacilities : [])
    } catch (error) {
      console.error('Unable to load facilities for patient service update', error)
      setFacilityDirectory([])
    }
  }

  useEffect(() => {
    loadFacilityDirectory()
  }, [])

  const getMatchingAppointmentForPatient = () => {
    if (!Array.isArray(appointment) || appointment.length === 0) return null

    return (
      appointment.find((item) => item?.data?.AppointmentID === patientAppointmentID) ||
      appointment.find((item) => item?.current?.Patient?.value === patientID) ||
      null
    )
  }

  const resolveFacilityInformation = (serviceValue = '', patientDetailsOverride = null) => {
    const patientDetails = patientDetailsOverride || currentPatientDetails || {}
    const matchedAppointment = getMatchingAppointmentForPatient()
    const facilityName =
      patientDetails?.FacilityName ||
      patientData?.FacilityName ||
      matchedAppointment?.data?.Facility ||
      matchedAppointment?.current?.Facility?.label ||
      ''
    const facilityType =
      patientDetails?.FacilityType ||
      patientData?.FacilityType ||
      matchedAppointment?.data?.FacilityType ||
      matchedAppointment?.current?.Facility?.Type ||
      matchedAppointment?.current?.Facility?.type ||
      ''
    const facilityIdCandidate =
      patientDetails?.FacilityID ||
      patientData?.FacilityID ||
      matchedAppointment?.data?.FacilityID ||
      matchedAppointment?.current?.Facility?.value ||
      matchedAppointment?.current?.Facility?.FacilityID ||
      ''
    const roomValue =
      patientDetails?.Room ||
      patientData?.Room ||
      matchedAppointment?.data?.Room ||
      ''

    const matchedFacility = facilityDirectory.find((facility) => {
      const facilityId = normalizeLookupValue(facility?.ID || facility?.FacilityID)
      const facilityLabel = normalizeLookupValue(facility?.Name || facility?.FacilityName)
      return (
        (facilityIdCandidate && facilityId && normalizeLookupValue(facilityIdCandidate) === facilityId) ||
        (facilityName && facilityLabel && normalizeLookupValue(facilityName) === facilityLabel)
      )
    })

    return {
      FacilityID: String(facilityIdCandidate || matchedFacility?.ID || matchedFacility?.FacilityID || ''),
      FacilityName: String(facilityName || matchedFacility?.Name || matchedFacility?.FacilityName || ''),
      Room: String(roomValue || ''),
      FacilityType: String(facilityType || matchedFacility?.Type || matchedFacility?.FacilityType || ''),
      patientType: patientDetails?.PatientType || patientDetails?.patientType || patientData?.PatientType || patientData?.patientType || '',
      Services: serviceValue,
    }
  }

  const waitFor = (delayMs) => new Promise((resolve) => {
    window.setTimeout(resolve, delayMs)
  })

  const findAppointmentNeedingNoteLink = () => {
    if (!Array.isArray(appointment) || appointment.length === 0) return null

    return (
      appointment.find(
        (item) =>
          item?.data?.AppointmentID === patientAppointmentID &&
          (item?.data?.Status === 'Scheduled' || item?.data?.Status === 'Rescheduled'),
      ) ||
      appointment.find(
        (item) =>
          item?.current?.Patient?.value === patientID &&
          (item?.data?.Status === 'Scheduled' || item?.data?.Status === 'Rescheduled') &&
          !item?.data?.NoteID,
      ) ||
      null
    )
  }

  const isNoteLinkedToAppointment = async (noteID) => {
    const appointmentToCheck = findAppointmentNeedingNoteLink()

    if (!appointmentToCheck || !noteID) return false

    const scheduleDate = appointmentToCheck?.data?.StartTime?.split?.(' ')?.[0] || ''
    const providerId = appointmentToCheck?.current?.Provider?.value
    const appointmentIdToCheck = appointmentToCheck?.data?.AppointmentID || patientAppointmentID

    if (!scheduleDate || !providerId || !appointmentIdToCheck) return false

    const latestAppointments = await getAllAppointmentsDetails(
      'GETBYSCHEDULEDATEANDPROVIDERID',
      scheduleDate,
      providerId,
    )

    const matchedAppointment = latestAppointments.find(
      (item) => String(item?.data?.AppointmentID) === String(appointmentIdToCheck),
    )

    return String(matchedAppointment?.data?.NoteID || '') === String(noteID)
  }

  const ensureNoteLinkedBeforeOpening = async (noteID) => {
    const appointmentToSync = findAppointmentNeedingNoteLink()

    if (!appointmentToSync) {
      toast.error('No scheduled appointment was found to link this note. Please try again.', toastConfig)
      return false
    }

    for (let attempt = 0; attempt < NOTE_LINK_MAX_RETRIES; attempt += 1) {
      if (await isNoteLinkedToAppointment(noteID)) {
        return true
      }

      if (attempt === 0) {
        await handleAddNoteId(noteID)
      } else {
        await waitFor(NOTE_LINK_RETRY_DELAY_MS)
      }
    }

    toast.error('NoteID is not linked with the appointment yet. Please try again.', toastConfig)
    return false
  }

  const isDraftOrSubmittedStatus = (status) => ['draft', 'drafted', 'in draft', 'submitted'].includes(normalizePatientStatus(status))

  const isRelinkEligibleNote = ({ item, displayedNoteStatus, appointmentNoteId, patienSeenData }) => {
    if (isPatientDischarged) return false
    if (!item?.id) return false
    if (appointmentNoteId) return false
    if (!patienSeenData) return false
    if (item?.status === 'Finished' || item?.status === 'Canceled') return false
    if (displayedNoteStatus === 'Signed') return false
    return isDraftOrSubmittedStatus(displayedNoteStatus || item?.status)
  }

  const handleRelinkExistingNote = async (item, noteIndexForItem) => {
    if (!item?.id || isRetryingLink) return

    try {
      setIsRetryingLink(true)
      setSyncingNoteId(item.id)

      localStorage.setItem('setEditDataIdLocal', item.id)
      localStorage.setItem('setDataCallTypeLocal', 'edit')
      localStorage.setItem('setNoteStatusLocal', getNoteStatus(item))
      localStorage.setItem('setPatientModalVisibleLocal', false)
      localStorage.setItem('setNoteIDLocal', noteIndexForItem)
      localStorage.setItem('noteStructureRefLocal', JSON.stringify(item?.data))

      const noteLinked = await ensureNoteLinkedBeforeOpening(item.id)
      if (!noteLinked) {
        return
      }

      toast.success('Note linked successfully.', toastConfig)
      window.open('/home/appointment', '_blank', 'noopener,noreferrer')
    } finally {
      setIsRetryingLink(false)
      setSyncingNoteId(null)
    }
  }

  const getResolvedFacilityType = (patientDetailsOverride = null) => {
    const patientDetails = hydratePatientRecord(patientDetailsOverride || currentPatientDetails || patientData || {})
    const matchedAppointment = getMatchingAppointmentForPatient()

    return String(
      patientDetails?.FacilityType ||
      patientData?.FacilityType ||
      matchedAppointment?.data?.FacilityType ||
      matchedAppointment?.current?.Facility?.Type ||
      matchedAppointment?.current?.Facility?.type ||
      '',
    ).trim()
  }

  const isCcrCFacilityPatient = (patientDetailsOverride = null) => {
    return getResolvedFacilityType(patientDetailsOverride).toLowerCase().startsWith('ccrc')
  }

  const sortNotesLatestFirst = (notes = []) => {
    return [...notes].sort((a, b) => {
      return getNoteId(b) - getNoteId(a) || getNoteTime(b) - getNoteTime(a)
    })
  }

  const GetPatientTreatmentsNotes = async () => {
    setIsPageLoading(true)
    try {
      let data
      data = await PatientNoteDataCRUD('GET', patientID)
      if (data) {
        data = JSON.parse(data.d)?.Data
        console.log("data for notes", data)
        data = data.map((item) => {
          return {
            ...item,
            data: item.data ? JSON.parse(item?.data) : {},
          }
        })

        data = sortNotesLatestFirst(data)

        setPatientTreatments(data)
        return data
      }
    } catch (error) {
      toast.error('error in patient treatment', toastConfig)
    } finally {
      setIsPageLoading(false)
    }
  }

  const Finish = () => {
    let finishNote = patientTreatments?.filter((item) => item.status === 'Finished')
    if (finishNote && finishNote?.length > 0) {
      setFinishNote(finishNote[finishNote.length - 1] || {})
    }
  }

  useEffect(() => {
    const patientDataFn = async () => {
      GetPatientTreatmentsNotes()
    }
    patientDataFn()
  }, [])

  const normalizeNoteStatus = (status) => String(status || '').trim().toLowerCase()

  const getLatestNoteStatus = (notes = []) => {
    if (!Array.isArray(notes) || notes.length === 0) return null
    const sortedNotes = [...notes].sort((a, b) => {
      const aDate = new Date(a.newDate || a.data?.CreatedDate || a.data?.createdDate || 0)
      const bDate = new Date(b.newDate || b.data?.CreatedDate || b.data?.createdDate || 0)
      return bDate - aDate
    })
    return normalizeNoteStatus(sortedNotes[0]?.status)
  }

  const deleteShall = async (id) => {
    // const formattedJson = JSON.stringify(noteStructureRef.current)
    await PatientDataCRUD('DELETE', patientID.toString(), id.toString())
    await GetPatientTreatmentsNotes()
    setDeleteVisibleId(null)
  }
  useEffect(() => {
    Finish()
  }, [patientTreatments])

  // const handleCreateNote = async () => {
  //   setCreatingNewNote(true)
  //   await PatientNoteDataCRUD('INSERT', patientID.toString(), '', JSON.stringify(noteStructureRef.current), getFormattedDate().toString())
  //   const patientTreatments = await GetPatientTreatmentsNotes()
  //   let recentlyCreatedNote
  //   if (patientTreatments.length > 1) {
  //     saveDiagnosisData({
  //       ...patientData,
  //       Status: 'Follow Up',
  //     })

  //     setNoteStatus('Follow Up')
  //   }
  //   if (patientTreatments.length > 0) {
  //     recentlyCreatedNote = patientTreatments[patientTreatments.length - 1]
  //     setEditDataId(recentlyCreatedNote?.id)
  //   }

  //   if (patientTreatments?.length !== 0) {
  //     setChildFormData((prev) => {
  //       return { ...prev, Status: 'Follow Up' }
  //     })

  //     let result = patientTreatments && patientTreatments.every((item) => item.status !== 'Signed')
  //     if (result) {
  //       setWarningModelVisible(true)
  //       setNoteID(patientTreatments.length - 1)
  //       SyncAppointmentData(recentlyCreatedNote?.id)
  //       setEditDataId(recentlyCreatedNote?.id)
  //       setDataCallType('edit')
  //       if (patientData?.Status === 'Follow Up') {
  //         //this is for case if the note id is 0 and patient created as followup then the hpi should not show, it should show the subjective, so for that we need to set the notestatus as followup.
  //         setNoteStatus('Follow Up')
  //       }
  //     } else {
  //       setEditDataId(recentlyCreatedNote?.id)
  //       setDataCallType('edit')
  //       setShowPatientInfo(true)
  //       setPatientModalVisible(false)
  //       setNoteID(patientTreatments.length - 1)
  //       SyncAppointmentData(recentlyCreatedNote?.id)
  //     }
  //   } else {
  //     console.log('else run')
  //     setChildFormData((prev) => {
  //       return { ...prev, Status: 'NewPatient' }
  //     })
  //     SyncAppointmentData(recentlyCreatedNote?.id)
  //     setNoteID(0)
  //     setDataCallType('newNote')
  //     setShowPatientInfo(true)
  //     setPatientModalVisible(false)
  //   }
  // }

  useEffect(() => {
    if (createdNoteId && appointment?.length > 0) {
      SyncAppointmentData(createdNoteId)
    }
  }, [createdNoteId, appointment])

  const closeSettingsModal = () => {
    setSettingsModalVisible(false)
    setSelectedSettingsNote(null)
    setFacilityOptions([])
    setSelectedService(null)
    setOriginalService('')
    setCurrentPatientDetails(null)
    setSettingsModalMode('edit')
  }

  const updatePatientForCreateNoteFlow = async ({ patientDetails, serviceValue, status }) => {
    const patientInsurances = await PatientInsuranceFn('SELECT', '', patientID)
    const insurances = parseInsuranceDetails(patientInsurances).map((insurance) => ({
      InsuranceID: insurance?.ID,
    }))

    const updatedPatientInformation = {
      ...(patientDetails || patientData || {}),
      services: serviceValue || '',
      Status: status || patientDetails?.Status || patientData?.Status || '',
    }

    const facilityInformation = resolveFacilityInformation(serviceValue, patientDetails)

    await SavePatients(
      'Update',
      JSON.stringify(updatedPatientInformation),
      JSON.stringify(facilityInformation),
      patientDetails?.Diagnosis || patientData?.Diagnosis || '',
      patientID,
      JSON.stringify(insurances),
    )
  }

  const continueCreateNote = async ({ patientDetailsOverride = null, selectedServiceValue = '' } = {}) => {
    if (!noteStructureRef?.current) {
      toast.error('Unable to create note from this screen. Please open a scheduled appointment first.', toastConfig)
      return
    }

    try {
      const normalizedSelectedService =
        selectedServiceValue ||
        patientDetailsOverride?.Services ||
        currentPatientDetails?.Services ||
        patientData?.Services ||
        ''
      const notePayload = {
        ...(noteStructureRef.current || {}),
        Service: normalizedSelectedService,
      }

      clearNoteCache(patientID)
      const existingPatientTreatments = await GetPatientTreatmentsNotes()

      if (!Array.isArray(existingPatientTreatments)) {
        toast.error('Unable to verify the last note status. Please try again.', toastConfig)
        return
      }

      const latestExistingNote = existingPatientTreatments?.[0]
      const latestExistingNoteStatus = latestExistingNote?.status || latestExistingNote?.Status
      const latestExistingNoteData = latestExistingNote?.data || {}
      const latestExistingNoteIsSigned =
        normalizePatientStatus(latestExistingNoteStatus) === 'signed' ||
        !!latestExistingNoteData?.signedAt ||
        !!latestExistingNoteData?.signatureInfo?.signedDate

      if (latestExistingNote && !latestExistingNoteIsSigned) {
        toast.error('Please sign the last note before creating a new one.', toastConfig)
        return
      }

      setCreatingNewNote(true)
      setNoteIdsBeforeCreate((existingPatientTreatments || []).map((item) => String(item?.id)))
      localStorage.setItem('setCreatingNewNote', true)
      localStorage.setItem('childFormdata', JSON.stringify(childformData))
      localStorage.setItem('patientId', patientID)
      await PatientNoteDataCRUD(
        'INSERT',
        patientID.toString(),
        '',
        JSON.stringify(notePayload),
        getFormattedDate().toString(),
        'Draft',
        'false',
        undefined,
        normalizedSelectedService,
      )
      const latestPatientTreatments = await GetPatientTreatmentsNotes()

      if (!Array.isArray(latestPatientTreatments) || latestPatientTreatments.length === 0) {
        console.error('No patient treatments found. Stopping execution.')
        toast.error('No patient treatments found. please try again', toastConfig)
        return
      }

      let recentlyCreatedNote
      const recentlyCreatedNoteStatus = latestPatientTreatments.length > 1 ? 'Follow Up' : 'New Note'
      if (latestPatientTreatments.length > 1) {
        await updatePatientForCreateNoteFlow({
          patientDetails: patientDetailsOverride || currentPatientDetails || patientData,
          serviceValue: normalizedSelectedService,
          status: 'Follow Up',
        })

        localStorage.setItem('saveDiagnosisData', 'Follow Up')
        localStorage.setItem('setNoteStatus', 'Follow Up')
      }
      if (latestPatientTreatments.length > 0) {
        recentlyCreatedNote = latestPatientTreatments[0]
        localStorage.setItem('setEditDataId', recentlyCreatedNote?.id)
        localStorage.setItem('setEditDataIdLocal', recentlyCreatedNote?.id)
        localStorage.setItem('setDataCallTypeLocal', 'edit')
        localStorage.setItem('setPatientIDClickedLocal', recentlyCreatedNote?.patientID)
        localStorage.setItem('setNoteStatusLocal', recentlyCreatedNoteStatus)
        localStorage.setItem('setNoteIDLocal', latestPatientTreatments.length - 1)
      }

      if (latestPatientTreatments?.length !== 0) {
        localStorage.setItem('setChildFormData', 'Follow Up')

        let result = latestPatientTreatments && latestPatientTreatments.every((item) => item.status !== 'Signed')
        if (result) {
          localStorage.setItem('setNoteID', latestPatientTreatments.length - 1)
          setCreatedNoteId(recentlyCreatedNote?.id)
          localStorage.setItem('SyncAppointmentData', recentlyCreatedNote?.id)
          localStorage.setItem('setEditDataId', recentlyCreatedNote?.id)
          localStorage.setItem('setEditDataIdLocal', recentlyCreatedNote?.id)
          localStorage.setItem('setPatientIDClickedLocal', recentlyCreatedNote?.patientID)
          localStorage.setItem('setNoteStatusLocal', recentlyCreatedNoteStatus)
          localStorage.setItem('setNoteIDLocal', latestPatientTreatments.length - 1)
          localStorage.setItem('setDataCallType', 'edit')
          if (patientData?.Status === 'Follow Up') {
            localStorage.setItem('setNoteStatus', 'Follow Up')
          }
          localStorage.setItem('patientDataStatusChange', 'Follow Up')
        } else {
          localStorage.setItem('setEditDataId', recentlyCreatedNote?.id)
          localStorage.setItem('setEditDataIdLocal', recentlyCreatedNote?.id)
          localStorage.setItem('setPatientIDClickedLocal', recentlyCreatedNote?.patientID)
          localStorage.setItem('setNoteStatusLocal', recentlyCreatedNoteStatus)
          localStorage.setItem('setNoteIDLocal', latestPatientTreatments.length - 1)
          localStorage.setItem('setDataCallType', 'edit')
          localStorage.setItem('setShowPatientInfo', true)
          localStorage.setItem('setPatientModalVisible', false)
          localStorage.setItem('setNoteID', latestPatientTreatments.length - 1)
          setCreatedNoteId(recentlyCreatedNote?.id)
        }
      } else {
        console.log('else run')
        localStorage.setItem('setChildFormDataStatus', 'NewPatient')
        setCreatedNoteId(recentlyCreatedNote?.id)
        localStorage.setItem('setNoteID', 0)
        localStorage.setItem('setNoteStatusLocal', recentlyCreatedNoteStatus)
        localStorage.setItem('setNoteIDLocal', 0)
        localStorage.setItem('setEditDataIdLocal', recentlyCreatedNote?.id)
        localStorage.setItem('setDataCallType', 'newNote')
        localStorage.setItem('setShowPatientInfo', true)
        localStorage.setItem('setPatientModalVisible', false)
      }
      localStorage.setItem('patientData', JSON.stringify(patientData))

      const noteLinked = await ensureNoteLinkedBeforeOpening(recentlyCreatedNote?.id)
      if (!noteLinked) {
        return
      }

      window.open('/home/appointment', '_blank', 'noopener,noreferrer')
    } finally {
      setCreatingNewNote(false)
      setNoteIdsBeforeCreate(null)
    }
  }

  const handleCreateNote = async () => {
    if (!noteStructureRef?.current) {
      toast.error('Unable to create note from this screen. Please open a scheduled appointment first.', toastConfig)
      return
    }

    let patientDetails = currentPatientDetails

    if (!patientDetails) {
      patientDetails = await fetchResolvedPatientDetails()
      if (patientDetails) {
        setCurrentPatientDetails(patientDetails)
      }
    }

    if (!isCcrCFacilityPatient(patientDetails)) {
      await continueCreateNote()
      return
    }

    setSettingsModalMode('create')
    setSelectedSettingsNote(null)
    setSettingsModalVisible(true)
  }

  useEffect(() => {
    const preloadPatientDetails = async () => {
      if (!patientID) return

      const patientDetails = await fetchResolvedPatientDetails()
      if (patientDetails) {
        setCurrentPatientDetails(patientDetails)
      }
    }

    preloadPatientDetails()
  }, [patientID, facilityDirectory])

  useEffect(() => {
    const shouldDisable = shouldDisableCreateNote({
      context: noteButtonContext,
      appointment,
      patientAppointmentID,
      patientTreatments,
    })
    setAllowCreateNote(shouldDisable)
  }, [patientTreatments, patientData, appointment, patientAppointmentID, noteButtonContext])

  const handleNoteView = (item, index) => {
    setAllPatientVisible(true)
    setNodeId(item.id)
    setNoteIndex(index)
  }

  const handleOpenSettingsModal = (item) => {
    setSelectedSettingsNote(item)
    setSettingsModalVisible(true)
  }

  useEffect(() => {
    const loadPatientDetails = async () => {
      if (!settingsModalVisible || !patientID) return

      setIsPatientDetailsLoading(true)
      setFacilityOptions([])
      setSelectedService(null)

      try {
        const patientRecord = await fetchResolvedPatientDetails()
        const options = parseFacilityTypeOptions(patientRecord?.FacilityType)
        const serviceValue = String(patientRecord?.Services || '').trim()
        const matchingService = options.find((option) => option.value === serviceValue) || null

        setFacilityOptions(options)
        setSelectedService(matchingService)
        setOriginalService(serviceValue)
        setCurrentPatientDetails(patientRecord)
      } catch (error) {
        console.error('Failed to load patient details for settings modal', error)
        setFacilityOptions([])
        setSelectedService(null)
        setOriginalService('')
        setCurrentPatientDetails(null)
      } finally {
        setIsPatientDetailsLoading(false)
      }
    }

    loadPatientDetails()
  }, [settingsModalVisible, patientID])

  const handleSaveSelectedService = async () => {
    if (!patientID || !currentPatientDetails || !selectedSettingsNote) {
      toast.error('Patient details not found. Please reopen the modal and try again.', toastConfig)
      return
    }

    setIsSavingService(true)

    try {
      const patientInsurances = await PatientInsuranceFn('SELECT', '', patientID)
      const insurances = parseInsuranceDetails(patientInsurances).map((insurance) => ({
        InsuranceID: insurance?.ID,
      }))

      const updatedPatientInformation = {
        ...currentPatientDetails,
        services: selectedService?.value || '',
      }

      const facilityInformation = resolveFacilityInformation(selectedService?.value || '')

      await SavePatients(
        'Update',
        JSON.stringify(updatedPatientInformation),
        JSON.stringify(facilityInformation),
        currentPatientDetails?.Diagnosis || '',
        patientID,
        JSON.stringify(insurances),
      )

      const updatedNoteData = {
        ...(selectedSettingsNote?.data || {}),
        Service: selectedService?.value || '',
      }

      await PatientNoteDataCRUD(
        'UPDATE',
        patientID.toString(),
        selectedSettingsNote?.id?.toString() || selectedSettingsNote?.Id?.toString() || '',
        JSON.stringify(updatedNoteData),
        selectedSettingsNote?.newDate || selectedSettingsNote?.date || getFormattedDate().toString(),
        selectedSettingsNote?.status || selectedSettingsNote?.Status || 'Draft',
        selectedSettingsNote?.flag === true || selectedSettingsNote?.flag === 'true' ? 'true' : 'false',
        undefined,
        selectedService?.value || '',
      )

      setCurrentPatientDetails((prev) =>
        prev
          ? {
            ...prev,
            Services: selectedService?.value || '',
          }
          : prev,
      )
      setPatientTreatments((prev) =>
        Array.isArray(prev)
          ? prev.map((note) =>
            note.id === selectedSettingsNote?.id
              ? {
                ...note,
                data: updatedNoteData,
                Services: selectedService?.value || '',
              }
              : note,
          )
          : prev,
      )
      toast.success('Service updated successfully', toastConfig)
      closeSettingsModal()
    } catch (error) {
      console.error('Failed to update patient service', error)
      toast.error('Failed to update service. Please try again.', toastConfig)
    } finally {
      setIsSavingService(false)
    }
  }

  const handleContinueCreateNote = async () => {
    if (!patientID || !currentPatientDetails) {
      toast.error('Patient details not found. Please reopen the modal and try again.', toastConfig)
      return
    }

    const normalizedOriginalService = String(originalService || '').trim()
    const normalizedSelectedService = String(selectedService?.value || '').trim()
    const serviceChanged = normalizedOriginalService !== normalizedSelectedService
    const patientDetailsSnapshot = {
      ...currentPatientDetails,
      Services: normalizedSelectedService || currentPatientDetails?.Services || '',
    }

    setIsSavingService(true)

    try {
      if (serviceChanged) {
        await updatePatientForCreateNoteFlow({
          patientDetails: patientDetailsSnapshot,
          serviceValue: normalizedSelectedService,
          status: patientDetailsSnapshot?.Status || '',
        })
      }

      closeSettingsModal()
      await continueCreateNote({
        patientDetailsOverride: patientDetailsSnapshot,
        selectedServiceValue: normalizedSelectedService,
      })
    } catch (error) {
      console.error('Failed to update patient service before note creation', error)
      toast.error('Failed to continue with note creation. Please try again.', toastConfig)
    } finally {
      setIsSavingService(false)
    }
  }

  const SyncAppointmentData = (noteID) => {
    console.log("SyncAppointmentData called", { noteID, appointment, patientID })

    if (!noteID) {
      console.warn("No noteID, skipping sync")
      return
    }

    if (!appointment || appointment.length === 0) {
      console.warn("No appointments available yet")
      return
    }

    let filterPatient = appointment.filter(
      (item) =>
        item.current.Patient.value === patientID &&
        (item.data.Status === 'Scheduled' || item.data.Status === 'Rescheduled') &&
        !item.data.NoteID
    )

    console.log("Filtered appointments:", filterPatient)

    if (filterPatient.length > 0) {
      handleAddNoteId(noteID)
    } else {
      console.warn("No matching appointment found to sync")
    }
  }
  // const SyncAppointmentData = (noteID) => {
  //   let filterPatient = appointment && appointment.length > 0 && appointment.filter((item) => item.current.Patient.value === patientID && (item.data.Status == 'Scheduled' || item.data.Status == 'Rescheduled') && !item.data.NoteID)

  //   if (filterPatient.length > 0) {
  //     if (noteID !== null || noteID !== undefined) {
  //       handleAddNoteId(noteID)
  //     }
  //   }
  // }

  useEffect(() => {
    const getData = () => {
      let filtered = allAppointment?.filter(
        (entry) => entry.patientID === patientID,
        // entry.appointmentDetails.find((appt) => appt.data?.Status === "Finish")
      )

      setPatientAllAppointment(filtered?.length > 0 ? filtered[0].appointmentDetails : [])
      // setHasFinishNote(filtered)
    }
    getData()
  }, [])

  const getNoteSequenceIndex = (item) => {
    return [...(patientTreatments || [])].sort((a, b) => getNoteId(a) - getNoteId(b) || getNoteTime(a) - getNoteTime(b)).findIndex((note) => note.id === item.id)
  }

  const getNoteStatus = (item) => {
    return getNoteSequenceIndex(item) <= 0 ? 'New Note' : 'Follow Up'
  }

  const getNoteStatusLabel = (item) => {
    const sequenceIndex = getNoteSequenceIndex(item)
    return sequenceIndex <= 0 ? 'New Note' : `${sequenceIndex} Follow Up`
  }


  console.log("patientTreatments", patientTreatments)
  const userData = JSON.parse(localStorage.getItem('user'))

  const role = userData?.Role
  return (
    <>
      <div className="patient-popup-dark">
        <CCard className="m-2 patient-popup-dark__toolbar-card">
          <CCardBody className="p-0">
            {showCreateNote && (
              <div className="d-flex align-items-center patient-popup-dark__toolbar">
                {/* <CButton
                  onClick={() => handleCreateNote()}
                  variant="outline"
                  color="primary"
                  // disabled={allowCreateNote}
                  disabled={allowCreateNote || creatingNewNote || isPatientDischarged}
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    opacity: allowCreateNote ? 0.5 : 1,
                    pointerEvents: allowCreateNote ? 'none' : 'auto',
                    borderColor: 'var(--cui-primary)',
                  }}
                >
                  {creatingNewNote ? (
                    <div className="d-flex align-items-center">
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                      <span style={{ fontSize: '14px', fontWeight: '500' }}>Creating...</span>
                    </div>
                  ) : (
                    <div className="d-flex align-items-center">
                      <CirclePlus size={16} strokeWidth={1.25} />
                      <div style={{ marginLeft: '8px', fontSize: '14px', fontWeight: '500' }}>Create Note</div>
                    </div>
                  )}
                </CButton> */}
{/* 
                   <CButton
                    onClick={() => handleCreateNote()}
                    variant="outline"
                    color="primary"
                    
                    className="d-flex align-items-center justify-content-center patient-popup-dark__create-btn ui-action-btn ui-action-btn--primary"
                     
                  >
                     <div className="d-flex align-items-center">
                        <CirclePlus size={16} strokeWidth={1.25} />
                        <div className="patient-popup-dark__create-btn-label">
                          Create Note
                        </div>
                      </div>
                  </CButton> */}
                <CTooltip
                  content={createNoteDisabledReason}
                  placement="top"
                  trigger={isDisabled ? ['hover', 'focus'] : []}
                  delay={{ show: 2000, hide: 0 }}
                >
                  <span style={{ display: 'inline-block', pointerEvents: 'auto' }}>
                    <CButton
                      onClick={() => handleCreateNote()}
                      variant="outline"
                      color="primary"
                      disabled={isDisabled}
                      className="d-flex align-items-center justify-content-center patient-popup-dark__create-btn ui-action-btn ui-action-btn--primary"
                      style={{
                        opacity: isDisabled ? 0.5 : 1,
                        cursor: isDisabled ? 'not-allowed' : 'pointer',
                      }}
                    >
                      {creatingNewNote ? (
                        <div className="d-flex align-items-center">
                          <span className="spinner-border spinner-border-sm me-2" />
                          <span style={{ fontSize: '14px', fontWeight: '500' }}>
                            Creating...
                          </span>
                        </div>
                      ) : (
                        <div className="d-flex align-items-center">
                          <CirclePlus size={16} strokeWidth={1.25} />
                          <div className="patient-popup-dark__create-btn-label">
                            Create Note 
                          </div>
                        </div>
                      )}
                    </CButton>
                  </span>
                </CTooltip>
              </div>
            )}
          </CCardBody>
        </CCard>

        <div className="m-2 p-2 rounded-1 overflow-auto patient-popup-dark__list">
          <div className="patient-popup-dark__list-inner">
            <CRow className="gy-4">

              {isPatientDischarged && (
                <CAlert color="warning" className="mb-3 mx-2">
                  <div className="d-flex align-items-center">
                    <CircleAlertIcon size={20} className="me-2" />
                    <span>This patient has been discharged. Notes can only be viewed, not created or edited.</span>
                  </div>
                </CAlert>
              )}

          {Array.isArray(visiblePatientTreatments) &&
visiblePatientTreatments.length === 0 ? (
  <CCol xs={12}>
    <div
      className="text-center py-4"
      style={{
        color: '#9CA3AF',
        fontSize: '14px',
      }}
    >
      No notes created for this patient.
    </div>
  </CCol>
) : (
  visiblePatientTreatments?.map((item, index) => {
                  let showTools = true
                  let appoinmentsData = appointment.filter((item) => item.data.AppointmentID === patientAppointmentID)
                  const appointmentNoteId = appoinmentsData?.[0]?.data?.NoteID
                  let patienSeenData = true
                  if (appoinmentsData?.length > 0 && !appointmentNoteId) {
                    showTools = false
                  }
                  if (appoinmentsData?.length > 0) {
                    let findCancelAppointmentData = appointment?.some((itemData) => itemData.current?.Patient.value === appoinmentsData[0]?.current?.Patient?.value && itemData?.data?.Status == 'Canceled')
                    if (findCancelAppointmentData) {
                      showTools = true
                    }
                  }

                  if (appoinmentsData?.length > 0) {
                    const result = appoinmentsData.some((item) => item.data.patientSeen === false)
                    if (result) {
                      patienSeenData = false
                    }
                  }
                  const noteSequenceIndex = getNoteSequenceIndex(item)
                  const noteIndexForItem = noteSequenceIndex === -1 ? index : noteSequenceIndex
                  const displayedNoteStatus = getDisplayedNoteStatus(item)
                  const displayedNoteService = getDisplayedNoteService(item)
                  const showServiceEditOption = isCcrCFacilityPatient() && displayedNoteStatus !== 'Signed'
                  const showRelinkButton = isRelinkEligibleNote({
                    item,
                    displayedNoteStatus,
                    appointmentNoteId,
                    patienSeenData,
                  })
                  return (
                    <CCol key={item.id} sm={12} className="d-flex ">
                      <CCard className="w-100 shadow-sm patient-popup-dark__note-card">
                        <CCardHeader className="d-flex justify-content-between align-items-center patient-popup-dark__note-header">
                          <h6 className="m-0 patient-popup-dark__note-title">{getNoteStatusLabel(item)}</h6>






                          {showTools ? (
                            <div className="d-flex align-items-center gap-1">
                              {showServiceEditOption && (
                                <button onClick={() => handleOpenSettingsModal(item)} className="btn btn-outline-info btn-sm" title="Open settings">
                                  <Settings size={16} strokeWidth={2.25} />
                                </button>
                              )}
                              {showOnlyViewEye ? (
                                <button onClick={() => handleNoteView(item, noteIndexForItem)} className="btn btn-outline-success btn-sm">
                                  <Eye size={16} strokeWidth={2.25} />
                                </button>
                              ) : item.status === 'Finished' || displayedNoteStatus === 'Signed' || item.status === 'Canceled' || patienSeenData == false ? (
                                <div className="d-flex align-items-center gap-1">
                                  <button onClick={() => handleNoteView(item, noteIndexForItem)} className="btn btn-outline-success btn-sm">
                                    <Eye size={16} strokeWidth={2.25} />
                                  </button>

                                  {/* Only show edit button if patient is NOT discharged */}
                                  {item.id === finishNote?.id && showViewIcon && !isPatientDischarged && (
                                    <button
                                      onClick={() => {
                                        setEditDataId(item.id)
                                        setDataCallType('edit')
                                        setNoteStatus(getNoteStatus(item))
                                        setPatientModalVisible(false)
                                        setNoteID(noteIndexForItem)
                                        noteStructureRef.current = item?.data
                                      }}
                                      className="btn btn-outline-warning btn-sm"
                                      title={isPatientDischarged ? "Cannot edit - Patient is discharged" : "Edit note"}
                                    >
                                      <Pencil size={16} strokeWidth={2.25} />
                                    </button>
                                  )}
                                </div>
                              ) : (
                                <button
                                  onClick={() => {
                                    if (isPatientDischarged) return; // Prevent edit if discharged
                                    localStorage.setItem('setEditDataIdLocal', item.id)
                                    localStorage.setItem('setDataCallTypeLocal', 'edit')
                                    localStorage.setItem('setNoteStatusLocal', getNoteStatus(item))
                                    setPatientModalVisible(false)
                                    localStorage.setItem('setPatientModalVisibleLocal', false)
                                    localStorage.setItem('setNoteIDLocal', noteIndexForItem)
                                    localStorage.setItem('noteStructureRefLocal', JSON.stringify(item?.data))
                                    window.open('/home/appointment', '_blank')
                                  }}
                                  className="btn btn-outline-warning btn-sm"
                                  disabled={isPatientDischarged}
                                  title={isPatientDischarged ? "Cannot edit - Patient is discharged" : "Edit note"}
                                  style={{
                                    opacity: isPatientDischarged ? 0.5 : 1,
                                    cursor: isPatientDischarged ? 'not-allowed' : 'pointer',
                                  }}
                                >
                                  <Pencil size={16} strokeWidth={2.25} />
                                </button>
                              )}
                            </div>
                          ) : (
                            <div className="patient-popup-dark__note-actions">
                              <button onClick={() => handleNoteView(item, noteIndexForItem)} className="btn btn-outline-success btn-sm">
                                <Eye size={16} strokeWidth={2.25} />
                              </button>
                              {showRelinkButton && (
                                <button
                                  onClick={() => handleRelinkExistingNote(item, noteIndexForItem)}
                                  className="btn btn-outline-primary btn-sm"
                                  disabled={isRetryingLink}
                                  title="Try to assign NoteID and reopen note"
                                >
                                  <RefreshCw
                                    size={16}
                                    strokeWidth={2.25}
                                    className={syncingNoteId === item.id ? 'patient-popup-dark__sync-icon--spinning' : ''}
                                  />
                                </button>
                              )}
                            </div>
                          )}






                          {/* <button onClick={() => { setDeleteVisibleId(true); setDeleteId(item.id); }} className="btn btn-outline-danger btn-sm"> */}
                          {/* <Trash2 size={16} strokeWidth={1.75} /> */}
                          {/* </button> */}
                        </CCardHeader>
                        <CCardBody className="d-flex align-items-center justify-content-between px-3 pt-0 patient-popup-dark__note-body">
                          <div className="patient-popup-dark__meta">
                            <div>Date: {new Date(item.date).toLocaleDateString('en-us')}</div>
                            {item.flag == 'true' && displayedNoteStatus == 'Draft' ? <div>Status: Provider {displayedNoteStatus}</div> : item.flag == 'true' && displayedNoteStatus == 'Signed' ? <div>Status:Provider {displayedNoteStatus}</div> : <div>Status: {displayedNoteStatus}</div>}
                            {isCcrCFacilityPatient() && displayedNoteService && <div>Service: {displayedNoteService}</div>}
                            {item.status === 'Canceled' && (
                              <div>
                                Reason:{' '}
                                {(() => {
                                  return item?.data?.NoteCancelReason || 'N/A'
                                })()}
                              </div>
                            )}
                          </div>
                        </CCardBody>
                      </CCard>
                    </CCol>
                  )
                }))}
            </CRow>
          </div>
        </div>

        {/* delete modal */}
        <CModal visible={deleteVisibleId}>
          <CModalHeader>
            <CModalTitle>Warning</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <p className="fs-6 p-0 m-0">Are you sure you want to delete?</p>
          </CModalBody>
          <hr className="p-0 m-0" />
          <CModalFooter className="p-3 m-0">
            <CButton
              onClick={() => {
                setDeleteVisibleId(null)
              }}
              className="text-white"
              color="secondary"
            >
              Close
            </CButton>
            <CButton onClick={() => deleteShall(deleteId)} className="text-white" color="danger">
              Delete
            </CButton>
          </CModalFooter>
        </CModal>

        <CModal
          visible={warningModelVisible}
          onClose={() => {
            ; (setWarningModelVisible(false), setWarningModelVisible(false))
          }}
        >
          <CModalHeader>
            <CModalTitle>Warning</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <p className="fs-6 p-0 m-0">Are you sure you want to create new note?</p>
          </CModalBody>
          <hr className="p-0 m-0" />
          <CModalFooter className="p-3 m-0">
            <CButton
              onClick={() => {
                setWarningModelVisible(false)
              }}
              className="text-white"
              color="secondary"
            >
              Close
            </CButton>
            <CButton
              onClick={() => {
                setDataCallType('newNote')
                setShowPatientInfo(true)
                setPatientModalVisible(false)
              }}
              className="text-white"
              color="warning"
            >
              Continue
            </CButton>
          </CModalFooter>
        </CModal>

        <CModal
          visible={settingsModalVisible}
          onClose={() => {
            closeSettingsModal()
          }}
        >
          <CModalHeader>
            <CModalTitle>Services</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <div className="d-flex flex-column gap-2">
              <div className="mt-2">
                <Select
                  value={selectedService}
                  onChange={setSelectedService}
                  options={facilityOptions}
                  isLoading={isPatientDetailsLoading}
                  isClearable
                  placeholder="Select facility type"
                  className="basic-single-select ui-react-select"
                  classNamePrefix="select"
                />
              </div>
            </div>
          </CModalBody>
          <hr className="p-0 m-0" />
          <CModalFooter className="p-3 m-0">
            {settingsModalMode === 'create' ? (
              <CButton
                onClick={handleContinueCreateNote}
                className="text-white"
                color="primary"
                disabled={isPatientDetailsLoading || isSavingService}
              >
                {isSavingService ? 'Continuing...' : 'Continue'}
              </CButton>
            ) : (
              <>
                <CButton
                  onClick={handleSaveSelectedService}
                  className="text-white"
                  color="primary"
                  disabled={isPatientDetailsLoading || isSavingService}
                >
                  {isSavingService ? <CSpinner size="sm" aria-hidden="true" /> : 'Save'}
                </CButton>
                <CButton
                  onClick={() => {
                    closeSettingsModal()
                  }}
                  className="text-white"
                  color="secondary"
                >
                  Close
                </CButton>
              </>
            )}
          </CModalFooter>
        </CModal>

        <CModal
          size="xl"
          visible={allPatientVisible}
          onClose={() => {
            ; (setAllPatientVisible(false), setShowNotePatient(false), setNodeId(null), setNoteIndex(null))
          }}
        >
          <CModalHeader
            style={
              role === 'provider'
                ? {
                  backgroundColor: '#282828',
                  borderBottom: '1px solid gray',
                  color: 'white',
                  display: 'flex',
                  justifyContent: 'center',
                  borderRadius: '10px 10px 0 0',
                }
                : {}
            }
            className={`${role === 'provider' ? 'dark-note-modal' : ''} `}
          >
            <CModalTitle style={{ color: role === 'provider' ? 'white' : 'inherit', width: '100%' }}>Note</CModalTitle>
          </CModalHeader>
          <CModalBody
            style={
              role === 'provider'
                ? {
                  backgroundColor: '#282828',
                  color: 'white',
                }
                : {}
            }
          >
            <div style={{ height: '45vw', overflow: 'auto' }}>
              <PatientInfoFreeType breadCrumbHref={breadCrumbHref} breadCrumbText={breadCrumbText} patientID={patientData.PatientID} patientData={patientData} dataCallType="edit" setDataId={noteId} noteID={noteIndex} showAllData={false} showNoteView={true} appointments={appointment} />
            </div>
          </CModalBody>

          <CModalFooter
            style={
              role === 'provider'
                ? {
                  backgroundColor: '#282828',
                  borderTop: '1px solid gray',
                  display: 'flex',
                  justifyContent: 'end',
                  gap: '10px',
                }
                : {}
            }
          >
            <CButton
              onClick={() => {
                setAllPatientVisible(false)
                setShowNotePatient(false)
                setNodeId(null)
                setNoteIndex(null)
              }}
              className="text-white"
              color="secondary"
            >
              Close
            </CButton>
          </CModalFooter>
        </CModal>
        <Pageloader isLoading={isPageLoading} />
      </div>
    </>
  )
}

export default PatientPopup



// Use This: if the patient status is discharged and the not shoud note be editable 
//                           {showTools ? (
//   <div className="d-flex align-items-center gap-1">
//     {showOnlyViewEye ? (
//       <button onClick={() => handleNoteView(item, index)} className="btn btn-outline-success btn-sm">
//         <Eye size={16} strokeWidth={2.25} />
//       </button>
//     ) : item.status === 'Finished' || item.status === 'Signed' || item.status === 'Canceled' || patienSeenData == false ? (
//       <div>
//         <button onClick={() => handleNoteView(item, index)} className="btn btn-outline-success btn-sm">
//           <Eye size={16} strokeWidth={2.25} />
//         </button>

//         {/* Only show edit button if patient is NOT discharged */}
//         {item.id === finishNote?.id && showViewIcon && !isPatientDischarged && (
//           <button
//             onClick={() => {
//               setEditDataId(item.id)
//               setDataCallType('edit')
//               setNoteStatus(getNoteStatus(item, index, patientData, patientAllAppointment))
//               setPatientModalVisible(false)
//               setNoteID(index)
//               noteStructureRef.current = item?.data
//             }}
//             className="btn btn-outline-warning btn-sm ms-1"
//             title={isPatientDischarged ? "Cannot edit - Patient is discharged" : "Edit note"}
//           >
//             <Pencil size={16} strokeWidth={2.25} />
//           </button>
//         )}
//       </div>
//     ) : (
//       <button
//         onClick={() => {
//           if (isPatientDischarged) return; // Prevent edit if discharged
//           localStorage.setItem('setEditDataIdLocal', item.id)
//           localStorage.setItem('setDataCallTypeLocal', 'edit')
//           localStorage.setItem('setNoteStatusLocal', getNoteStatus(item, index, patientData, patientAllAppointment))
//           setPatientModalVisible(false)
//           localStorage.setItem('setPatientModalVisibleLocal', false)
//           localStorage.setItem('setNoteIDLocal', index)
//           localStorage.setItem('noteStructureRefLocal', JSON.stringify(item?.data))
//           window.open('/home/appointment', '_blank')
//         }}
//         className="btn btn-outline-warning btn-sm"
//         disabled={isPatientDischarged}
//         title={isPatientDischarged ? "Cannot edit - Patient is discharged" : "Edit note"}
//         style={{
//           opacity: isPatientDischarged ? 0.5 : 1,
//           cursor: isPatientDischarged ? 'not-allowed' : 'pointer',
//         }}
//       >
//         <Pencil size={16} strokeWidth={2.25} />
//       </button>
//     )}
//   </div>
// ) : (
//   <button onClick={() => handleNoteView(item, index)} className="btn btn-outline-success btn-sm">
//     <Eye size={16} strokeWidth={2.25} />
//   </button>
// )}
